// extracted by mini-css-extract-plugin
module.exports = {"cookieBanner":"mod-g5G4g9YN","cookieBannerInner":"mod-3hYDDFsY","acceptCookiesButton":"mod-1LOURLm6","cookieSettings":"mod-m829_wGK"};